// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios'; // ⬅️ Agregado

// ✅ Muy importante: habilita cookies en las peticiones cross-origin
axios.defaults.withCredentials = true;
axios.defaults.baseURL = 'http://localhost:8080'; // opcional

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
